module.exports = __webpack_public_path__ + "static/img/user.822e5fb4.png";